import {Component} from "react";
import {FixedSizeList} from 'react-window';
import {AutoSizer} from 'react-virtualized';
import {inject} from "mobx-react";
import {UiStore} from "../../../../stores/uiStore";

@inject("uiStore")

export class TrainSlider extends Component<any, any> {
    cachedExercises: Array<unknown>
    render() {
        if (this.props?.isShuffled && !this.cachedExercises) {
            const temp = [...this.props.exercises]
            for (let i = temp.length - 1; i > 0; i--) {
                let j = Math.floor(Math.random() * (i + 1));
                [temp[i], temp[j]] = [temp[j], temp[i]];
            }
            this.cachedExercises = temp
        }
        else if (!this.cachedExercises) {
            this.cachedExercises = this.props.exercises
        }

        const uiStore: UiStore = this.props.uiStore;
        return (
            <div style={{height: '175px'}}>
                <AutoSizer>
                    {({ width, height }) => (
                        <FixedSizeList className="menuSlider trainslider" layout="horizontal" height={height} width={width} itemSize={280}
                                       itemCount={this.props.exercises.length}  itemData={this.cachedExercises}>
                            {props => {
                                const {data, index, style} = props;
                                const train = data[index];
                                return (
                                    <div className="item" key={train.id} style={style}>
                                        <a className="trainslider__a"
                                           onClick= {() => {
                                               uiStore.trainModal[train.id] = true;
                                           }}
                                        >
                                            <svg className="excercisePlay" width="39" height="39" viewBox="0 0 39 39" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <rect width="39" height="39" rx="19.5" fill="white"/>
                                                <path
                                                    d="M16.4849 12.1041C16.6047 12.0347 16.7388 12 16.8731 12C17.007 12 17.141 12.0347 17.2613 12.1041L26.5151 18.8278C26.7549 18.9663 26.9034 19.2228 26.9034 19.5001C26.9034 19.7774 26.7553 20.0338 26.5151 20.1722L17.2613 26.8962C17.0212 27.0346 16.7251 27.0346 16.4851 26.8962C16.2449 26.7574 16.0967 26.5008 16.0967 26.2237V12.7763C16.0967 12.4992 16.2447 12.2427 16.4849 12.1041Z"
                                                    fill="#F55555"/>
                                            </svg>
                                            <img className="trainPreview" src={`https://img.youtube.com/vi/${train.href}/mqdefault.jpg`} alt={train.title}/>
                                        </a>
                                    </div>
                                )
                            }}
                        </FixedSizeList>
                    )}
                </AutoSizer>
            </div>
        );
    }
}